<template>
    <div class="c-cart c-cart--size js-size"  v-bind:class="{'c-cart--open': sizeGuideOpen}"> <!-- cart -->
        
        <a id="ring-size" href="" v-on:click="closeSizeGuide($event)" class="c-cart__header">
            <span class="c-cart__headerText">Size guide</span>
            <span class="c-cart__headerText">Close</span>
        </a>
        
        <div class="c-cart__text">
            <p>Because we make each ring individually, you can order the exact size you require. If you are unsure of your size, your best option is to go to a local jewellery and ask them to size your finger. Feel free to specify a different size by selecting "Custom" from the size dropdown.</p>
            <p>We work in US and letter sizing and our most popular sizes are 5.5 (small), 7 (medium), 8.5 (large).</p>
            <p>Alternatively you can measure your finger and use our calculator. If your knuckle is (a lot) larger than the base of your finger then measure your knuckle as well and choose a size between the two. In most cases this shouldn't be an issue.</p>
            <ol>
                <li>
                    <p>Cut a strip of paper or a thin string at least 8 cm. Or use measuring tape.</p>
                </li>
                <li><p>Wrap it around your ring finger at the base of the finger joint.</p></li>
                <li><p>Using a pen or pencil, mark where the ends overlap.</p></li>
                <li><p>Lay it flat and use a ruler to measure the length in millimeters (MM).</p></li>
            </ol>
            <span class="c-cart__finger-display">
                <img src="../assets/measure-size.png" height="150" loading="lazy" alt="person measuring finger with paper"/>
                <div class="c-field c-form--contact">
                    <label class="c-field__label" for="RingSizeMM">Finger circumference (mm)</label>
                    <input class="c-field__input" name="RingSizeMM" v-model="ringSizeMM" type="number" placeholder="60mm" />
                    <div class="c-cart__size-result">
                        {{calculatorResult}}
                    </div>
                </div>
            </span>
        </div>

        <div class="c-cart__totals">
            <a href="" class="c-btn c-btn__link" v-on:click="closeSizeGuide($event)">Continue shopping</a>
        </div>
    </div>
</template>

<script>
    const sizeMatrix = [
        {Value:"A", Key:37.54},
        {Value:"A 1/2", Key:38.26},
        {Value:"B", Key:38.86},
        {Value:"B 1/2", Key:39.58},
        {Value:"C", Key:40.15},
        {Value:"C 1/2", Key:40.84},
        {Value:"D", Key:41.50},
        {Value:"D 1/2", Key:42.13},
        {Value:"E", Key:42.76},
        {Value:"E 1/2", Key:43.45},
        {Value:"F", Key:44.14},
        {Value:"F 1/2", Key:44.45},
        {Value:"F 3/5", Key:44.77},
        {Value:"G", Key:45.11},
        {Value:"G 1/4", Key:45.40},
        {Value:"G 1/2", Key:45.74},
        {Value:"H", Key:46.02},
        {Value:"H 1/2", Key:46.68},
        {Value:"I", Key:47.25},
        {Value:"I 1/2", Key:47.97},
        {Value:"J", Key:48.38},
        {Value:"J 1/4", Key:48.79},
        {Value:"J 1/2", Key:49.32},
        {Value:"K", Key:49.64},
        {Value:"K 1/4", Key:49.95},
        {Value:"K 1/2", Key:50.27},
        {Value:"L", Key:50.58},
        {Value:"L 1/4", Key:51.21},
        {Value:"L 1/2", Key:51.55},
        {Value:"M", Key:51.87},
        {Value:"M 1/2", Key:52.50},
        {Value:"N", Key:53.16},
        {Value:"N 1/2", Key:53.82},
        {Value:"O", Key:54.51},
        {Value:"O 1/2", Key:54.82},
        {Value:"P", Key:55.76},
        {Value:"P 1/2", Key:56.45},
        {Value:"Q", Key:57.15},
        {Value:"Q 1/2", Key:57.65},
        {Value:"Q 3/4", Key:58.21},
        {Value:"R", Key:58.47},
        {Value:"R 1/4", Key:58.72},
        {Value:"R 1/2", Key:59.06},
        {Value:"R 3/4", Key:59.34},
        {Value:"S", Key:60.00},
        {Value:"S 1/4", Key:60.38},
        {Value:"S 1/2", Key:60.66},
        {Value:"S 3/4", Key:60.98},
        {Value:"T", Key:61.29},
        {Value:"T 1/4", Key:61.64},
        {Value:"T 1/2", Key:62.33},
        {Value:"U", Key:62.89},
        {Value:"U 1/2", Key:63.46},
        {Value:"V", Key:63.84},
        {Value:"V 1/4", Key:64.21},
        {Value:"V 1/2", Key:64.97},
        {Value:"W", Key:65.22},
        {Value:"W 1/4", Key:65.50},
        {Value:"W 1/2", Key:65.78},
        {Value:"W 3/4", Key:66.22},
        {Value:"X", Key:66.54},
        {Value:"X 1/4", Key:66.73},
        {Value:"X 1/4", Key:66.92},
        {Value:"Y", Key:67.51},
        {Value:"Y 1/2", Key:68.14},
        {Value:"Z", Key:68.77},
        {Value:"Z + 1/2", Key:69.43},
        {Value:"Z + 1", Key:70.15},
        {Value:"Z + 1.5", Key:71.00},
    ]
    export default {
        name: 'RingSize',
        data: function() {
            return {
                sizeGuideOpen: false,
                ringSizeMM: Number,
                calculatorResult: ""
            }
        },
        watch: {
            ringSizeMM: function(newVal, oldVal) {
                var self = this;
                
                if (newVal > 0 && newVal < 10) {
                    self.calculatorResult = "That seems too small";
                }
                if (newVal > 10 && newVal < 37.4) {
                    self.calculatorResult = "Our sizing system doesn't go that small. You can specify the size in the order notes if you're sure.";
                }
               
                for (var i = 0; i < sizeMatrix.length; i++){
                    if (newVal == sizeMatrix[i].Key){
                        self.calculatorResult = "Your ring size is: " + sizeMatrix[i].Value;
                    } else if (i + 1 < sizeMatrix.length){
                        if (newVal > sizeMatrix[i].Key && newVal < sizeMatrix[i + 1].Key) {
                            self.calculatorResult = "Your ring size is: " + sizeMatrix[i].Value;
                        }
                    }
                }
                if (newVal < -10000) {
                    self.calculatorResult = "R.I.P";
                    return;
                }
                if (newVal < -1000) {
                    self.calculatorResult = "I've had enough. Stop being childish.";
                    return;
                }
                if (newVal < -100) {
                    self.calculatorResult = "Wow. Ok. That's how it is eh?";
                    return;
                }
                if (newVal < -10) {
                    self.calculatorResult = "We're not even sure what a ring that size would look like.";
                    return;
                }
                if (newVal < 0) {
                    self.calculatorResult = "So your finger has a circumference of less than zero?";
                    return;
                }
                if (newVal > 999999999) {
                    self.calculatorResult = "R.I.P";
                    return;
                }
                if (newVal > 99999999) {
                    self.calculatorResult = "Don't do it.";
                    return;
                }
                if (newVal > 9999999) {
                    self.calculatorResult = "Really? You're still going?";
                    return;
                }
                if (newVal > 999999) {
                    self.calculatorResult = "WOW";
                    return;
                }
                if (newVal > 99999) {
                    self.calculatorResult = "Your finger has the circumference of a football field. Okay. Sure.";
                    return;
                }
                if (newVal > 9999) {
                    self.calculatorResult = "Freak.";
                    return;
                }
                if (newVal > 150) {
                    self.calculatorResult = "Okay now you're having a laugh.";
                    return;
                }
                if (newVal > 99) {
                    self.calculatorResult = "That seems pretty large are you sure?";
                    return;
                }
                 if (newVal > 71.00) {
                    self.calculatorResult = "Our sizing system doesn't go that large. You can specify the size in the order notes if you're sure.";
                    return;
                }
            },
            sizeGuideOpen: function(){
                if (this.sizeGuideOpen && window.matchMedia("(max-width:765px)").matches){
                    $('html, body').animate({
                        scrollTop: $("#ring-size").offset().top
                    }, 500);
                }
            }
        },
        methods: {
            toggleSizeGuide: function() {
                this.sizeGuideOpen = !this.sizeGuideOpen;
                this.$parent.calcSizeGuide(this.sizeGuideOpen);
            },
            closeSizeGuide: function(e) {
                e.preventDefault();
                this.sizeGuideOpen = !this.sizeGuideOpen;
                this.$parent.calcSizeGuide(this.sizeGuideOpen);
            }
        },
    }
</script>




// WEBPACK FOOTER //
// RingSize.vue?7af6251d